__turbopack_context__.v({
  "image": "Image-module-scss-module__8TkDbG__image",
  "imageZoomEnabled": "Image-module-scss-module__8TkDbG__imageZoomEnabled",
});
